module.exports = __webpack_public_path__ + "img/likeUnfilled.774e51e4.png";